import axios from 'axios'

export default {
  create (order) {
    return axios
      .post(`/api/create-paypal-order`, order)
      .then(res => res.data)
  },

  capture (orderId) {
    return axios
      .post(`/api/orders/${orderId}/capture`)
      .then(res => res.data)
  }
}
